const listeners = new Map();

export const eventBus = {
  on(event, callback) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(callback);
  },
  off(event, callback) {
    listeners.get(event)?.delete(callback);
  },
  emit(event, ...args) {
    listeners.get(event)?.forEach((cb) => cb(...args));
  },
};